<template lang="html">
  <div class="scroll-out" style="flex-grow: 1; display: flex; flex-direction: column; max-height: 100%;">
    <div class="d-flex align-items-center justify-content-between">
      <div class="text-primary cta-3" style="margin-top:-15px;">
        <span v-if="!consultant">Total : </span> <b>{{ filtered_review_set.totalCount }}</b> avis
      </div>
      <div class="w-100 w-lg-auto search-input-container border border-separator"
           style="background-color:#fff;margin-top:-5px;margin-bottom:10px;">
        <input class="form-control search"
               ref="searchBox"
               v-model="filters.search_string"
               type="text"
               autocomplete="off"
               placeholder="Rechercher"/>
        <span class="search-magnifier-icon">
                    <svg xmlns="http://www.w3.org/2000/svg"
                         width="20"
                         height="20"
                         viewBox="0 0 20 20"
                         fill="none"
                         stroke="currentColor"
                         stroke-width="1.5"
                         stroke-linecap="round"
                         stroke-linejoin="round"
                         class="acorn-icons acorn-icons-search undefined">
                        <circle cx="9" cy="9" r="7">
                        </circle>
                        <path d="M14 14L17.5 17.5"></path>
                    </svg>
                </span>
      </div>
    </div>
    <div class="d-flex align-items-center justify-content-center">
      <div class="is-pulled-right pad ">
                <span class="icon" v-if="loading">
                    <i class="fas fa-spinner fa-spin"></i>
                </span>
      </div>
    </div>
    <div style="float:right;height:0px;z-index:1000;top:-35px;position:relative;"
         v-if="canGenerateResponses">
      <button @click="batch_reviews_generate_logos_answer()"
              class="btn btn-primary btn-sm">
        Générer des réponses
      </button>
    </div>


    <div ref="list" class="scroll custom-scroll" style="flex-grow: 1;" v-if="!loading">
      <div v-for="item in filtered_review_set.results"
           @click="select(item.uid)">
        <div class="card mb-2 cursor-pointer hover-border-primary"
             :class="{'selected': item.uid == $store.state.selected_review_uid}">
          <div class="card-body p-3">
            <div class="d-flex justify-content-between align-items-center">
              <div class="" style="width:90px;">
                                <span class="d-block text-primary">
                                    {{ item.published_on|local_date }}&nbsp;
                                </span>
              </div>

              <div class="d-flex">
                <div class="d-flex" style="padding-left:15px;height:20px;">
                  <div style="width:90px;overflow:hidden;text-overfow:ellipsis;white-space: nowrap;">
                    {{ item.platform.name }}
                  </div>
                  <span>&nbsp;{{ item.mark|round(1) }}</span>
                </div>
                <div class="d-flex" style="padding-left:4px; padding-right:15px;">
                  <div>
                    <i class="icon-12 "
                       :class="{'text-success bi-hand-thumbs-up-fill':item.positive, 'text-danger bi-hand-thumbs-down-fill': !item.positive}"></i>
                  </div>
                </div>
              </div>
              <div class="w-50">
                                <span class="badge list-badge bg-pink text-uppercase custom-badge"
                                      v-if="item.current_state"
                                      :class="get_class(item.current_state.class_name)">
                                    {{ item.current_state.verbose_name }}
                                    {{ get_tag_name(item.current_state.tag) }}
                                </span>
                <span class="badge" v-else="v-else">NO STATE</span>
              </div>
            </div>

            <div class="col-12">

              <span class="clamp-line small" data-line="1"
                    v-if="[null, ''].indexOf(item.title_fr) &lt; 0">{{ item.title_fr }}</span>
              <span class="clamp-line small" data-line="1"
                    v-else-if="[null, ''].indexOf(item.title_native) &lt; 0">{{ item.title_native }}</span>
              <span class="clamp-line small" data-line="1" v-else="v-else">Pas de titre </span>

            </div>
            <div class="d-flex justify-content-between mt-1">
              <div class="w-100 d-flex align-items-center">
                <span class="d-block text-primary small ">{{ item.author }}</span>
              </div>
              <div class="d-flex align-items-center"
                   v-if="$store.state.profile.is_superuser">
                <a :href="getTaskUrl(item.task_uid)" v-if="item.task_uid" target="_blank">
                  <i style="margin-right: 6px;" class="icon-16"
                     :title="getStatusTitle(item.task_status)"
                     :class="{
                                                'text-warning bi-hourglass-split': item.task_status === 'PENDING',
                                                'text-success bi-check-circle-fill': item.task_status === 'SUCCESS',
                                                'text-danger bi-exclamation-circle-fill': item.task_status === 'FAILED',
                                                'text-info bi-arrow-repeat': item.task_status === 'IN_PROGRESS'
                                                }">
                  </i>
                </a>
              </div>
              <div class="d-flex align-items-center"
                   v-if="!$store.state.profile.is_superuser">
                <a target="_blank">
                  <i style="margin-right: 6px;" class="icon-16"
                     :title="getStatusTitle(item.task_status)"
                     :class="{
                                                'text-warning bi-hourglass-split': item.task_status === 'PENDING',
                                                'text-success bi-check-circle-fill': item.task_status === 'SUCCESS',
                                                'text-danger bi-exclamation-circle-fill': item.task_status === 'FAILED',
                                                'text-info bi-arrow-repeat': item.task_status === 'IN_PROGRESS'
                                                }">
                  </i>
                </a>
              </div>

              <div class="w-100" v-if="consultant != null">
                                <span class="d-flex justify-content-end align-items-center small"
                                      :title="item.establishment.name">

                                    <div class="">
                                        <img :src="backendUrl + consultant.avatar"
                                             class="card-img rounded-xl sh-3 sw-3 me-2" alt="thumb">
                                    </div>
                                    {{ consultant.fullname }}
                                </span>
              </div>
              <div class="w-100" v-else>
                                <span class="d-block text-end small" :title="item.establishment.name">
                                    <i v-if="item.establishment.custom_text_1.toLowerCase() == 'gîte'"
                                       class="icon-16 me-2 bi-shop"></i>
                                    <svg v-else-if="item.establishment.custom_text_1.toLowerCase() == 'restaurant'"
                                         class="icon-list me-2" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 448 512"><path
                                        d="M42.6 .2c8.7 1.5 14.6 9.7 13.2 18.4L32.7 157.4c-.4 2.6-.7 5.2-.7 7.9L32 176c0 26.5 21.5 48 48 48l32 0 32 0c26.5 0 48-21.5 48-48l0-10.7c0-2.6-.2-5.3-.7-7.9L168.2 18.6c-1.5-8.7 4.4-17 13.2-18.4s17 4.4 18.4 13.2l23.1 138.8c.7 4.3 1.1 8.7 1.1 13.2l0 10.7c0 44.2-35.8 80-80 80l-16 0 0 240c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-240-16 0c-44.2 0-80-35.8-80-80l0-10.7c0-4.4 .4-8.8 1.1-13.2L24.2 13.4C25.7 4.7 33.9-1.2 42.6 .2zM88.8 0c8.8 .4 15.6 8 15.2 16.8l-8 160c-.4 8.8-8 15.6-16.8 15.2s-15.6-8-15.2-16.8l8-160C72.5 6.4 80-.4 88.8 0zm46.4 0C144-.4 151.5 6.4 152 15.2l8 160c.4 8.8-6.4 16.3-15.2 16.8s-16.3-6.4-16.8-15.2l-8-160C119.6 8 126.4 .5 135.2 0zM320 176l0 112c0 17.7 14.3 32 32 32l64 0 0-287.8-.2 .1c-1.7 .4-6.7 1.5-14.3 4.6C391.4 41 379 47.8 367 58.2c-23.2 20.1-47 55.3-47 117.8zM416 0c17.7 0 32 14.3 32 32l0 288 0 16 0 16 0 144c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-144-64 0c-35.3 0-64-28.7-64-64l0-112C288 32 400 0 416 0z"/></svg>
                                    <svg v-else-if="item.establishment.custom_text_1.toLowerCase() == 'camping'"
                                         class="icon-list me-2" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 576 512"><path
                                        d="M394.3 3.7c6.8 5.7 7.7 15.8 2 22.5L308.9 130.4 532.8 397.2C540 405.8 544 416.7 544 428l0 36c0 26.5-21.5 48-48 48l-208 0L80 512c-26.5 0-48-21.5-48-48l0-36c0-11.3 4-22.2 11.2-30.9L267.1 130.4 179.7 26.3c-5.7-6.8-4.8-16.9 2-22.5s16.9-4.8 22.5 2L288 105.5 371.7 5.7c5.7-6.8 15.8-7.7 22.5-2zM67.7 417.7c-2.4 2.9-3.7 6.5-3.7 10.3l0 36c0 8.8 7.2 16 16 16l49.9 0 1.5-1.9 144-184c3-3.9 7.7-6.1 12.6-6.1s9.6 2.3 12.6 6.1l144 184 1.5 1.9 49.9 0c8.8 0 16-7.2 16-16l0-36c0-3.8-1.3-7.4-3.7-10.3L288 155.3 67.7 417.7zM170.6 480L288 480l117.4 0L288 330 170.6 480z"/></svg>
                                    <svg v-else
                                         class="icon-list me-2" xmlns="http://www.w3.org/2000/svg"
                                         viewBox="0 0 448 512"><path
                                        d="M64 64C46.3 64 32 78.3 32 96l0 320c0 17.7 14.3 32 32 32l320 0c17.7 0 32-14.3 32-32l0-320c0-17.7-14.3-32-32-32L64 64zM0 96C0 60.7 28.7 32 64 32l320 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zm336 48l0 112 0 112c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-96-160 0 0 96c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-224c0-8.8 7.2-16 16-16s16 7.2 16 16l0 96 160 0 0-96c0-8.8 7.2-16 16-16s16 7.2 16 16z"/></svg>
                                    {{ item.establishment.name|ellipsis(5) }}
                                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "../gqlService";
import Fuse from "fuse.js";
import DropDown from "@/components/DropDown.vue";
import settings from "../settings";
import queries from "@/gql/queries";
import mutations from "@/gql/mutations";

const reviewHeight = 117;

export default {
  name: "ReviewList",
  components: {DropDown},
  props: {
    consultant_uid: String,
    establishment_uid: String,
    height: String,
    autoload: {
      type: Boolean,
      default: false,
    },
    filters: {
      type: Object,
      default: () => ({
        positive: false,
        search_string: "",
        classified: false,
        establishment: {name: null, uid: null},
        sentiment: null,
        status: null,
      }),
    },
    consultant: null,
  },
  data() {
    return {
      loading: true,
      review_set: new gql.DataHolder({
        model: "review_set",
        fields:
            "uid title_fr title_native text_fr author positive mark published_on establishment {uid name custom_text_1} platform {name} positive current_state {verbose_name class_name tag} task_status",
        autoload: this.autoload,
        filters: `establishment__consultant__uid:"${this.consultant_uid}", current_state__class_name__neq:"Classified", establishment__active: true`,
        reload_on_models: ["state_set"],
      }),
      backendUrl: settings.backendMediaUrl,
    };
  },
  computed: {
    style() {
      return {
        height: this.height,
      };
    },
    filtered_review_set() {
      const vm = this;
      let result = vm.review_set.results.map((r) => r);

      if (vm.filters.search_string !== "") {
        const fuse = new Fuse(vm.review_set.results, {
          keys: [
            {name: "text_fr", weight: 1.0},
            {name: "title_fr", weight: 1.0},
            {name: "title_native", weight: 0.5},
            {name: "author", weight: 0.7},
            {name: "establishment.name", weight: 0.3},
            {name: "platform.name", weight: 0.3},
          ],
          minMatchCharLength: 5,
          distance: 2000,
          threshold: 0.4,
          isCaseSensitive: false,
        });
        result = fuse.search(vm.filters.search_string).map((r) => r.item);
      }

      const processed = result.reduce((acc, el) => {
        if (el.task_status != null) {
          if (el.task_status.includes(",")) {
            const parts = el.task_status.split(",");
            el.task_uid = parts[0];
            el.task_status = parts[1];
          }
        }
        acc.push(el);
        return acc;
      }, []);

      processed.sort((a, b) => {
        return b.published_on > a.published_on
            ? 1
            : a.published_on > b.published_on
                ? -1
                : 0;
      });

      return {
        results: processed,
        totalCount: processed.length,
      };
    },
    canGenerateResponses() {
      return (
          this.filters.sentiment &&
          this.filters.status &&
          this.filters.sentiment.value &&
          this.filters.status.value === "New"
      );
    },
  },
  methods: {
    get_tag_name(tag) {
      return tag ? this.$store.state.tag_name[tag.toLowerCase()] : null;
    },
    keydown(e) {
      if (e.target.tagName !== "TEXTAREA") {
        if (e.keyCode === 40 || e.keyCode === 38) {
          e.preventDefault();
        }
      }
    },
    keyup(e) {
      if (e.target.tagName !== "TEXTAREA") {
        if (e.keyCode === 40) this.next();
        if (e.keyCode === 38) this.prev();
      }
    },
    next() {
      const index = this.filtered_review_set.results.findIndex(
          (r) => r.uid === this.$store.state.selected_review_uid
      );
      if (index + 1 < this.filtered_review_set.results.length) {
        this.select(this.filtered_review_set.results[index + 1].uid);
      }
      const visibleObjects = Math.floor(
          this.$refs["list"].offsetHeight / reviewHeight
      );
      const toScroll = index * reviewHeight - (visibleObjects - 2) * reviewHeight;
      if (toScroll > 0) this.$refs["list"].scroll(0, toScroll);
    },
    prev() {
      const index = this.filtered_review_set.results.findIndex(
          (r) => r.uid === this.$store.state.selected_review_uid
      );
      if (index - 1 >= 0) {
        this.select(this.filtered_review_set.results[index - 1].uid);
      }
      const visibleObjects = Math.floor(
          this.$refs["list"].scrollTop / reviewHeight
      );
      const scrolled = this.$refs["list"].scrollTop;
      const toScroll = index * reviewHeight - (visibleObjects + 2) * reviewHeight;
      if (toScroll < 0)
        this.$refs["list"].scroll(0, scrolled + toScroll);
    },
    select(uid) {
      this.$router.push({name: "flow_detail", params: {uid}});
    },
    debug() {
      setTimeout(() => {
        this.debug();
      }, 1000);
    },
    get_class(state_name) {
      return ["state-" + state_name.toLowerCase()];
    },
    build_filters() {
      const filters = {
        "establishment__consultant__uid": this.consultant_uid,
        "establishment__active": true,
      };
      if (!this.filters.classified) {
        filters["current_state__class_name__neq"] = "Classified";
      }
      if (this.filters.establishment.uid) {
        filters["establishment"] = this.filters.establishment.uid;
      }
      if (this.filters.platform.uid) {
        filters["platform"] = this.filters.platform.uid;
      }
      if (this.filters.sentiment.value != null) {
        filters["positive"] = this.filters.sentiment.value;
      }
      if (this.filters.status.value) {
        filters["current_state__class_name"] = this.filters.status.value;
      }
      if (this.filters.dateEnd) {
        filters["published_on__lte"] = this.filters.dateEnd;
      }
      if (this.filters.dateBegin) {
        filters["published_on__gte"] = this.filters.dateBegin;
      }
      if (this.filters.tag.name != null) {
        filters["current_state__tag__iexact"] = this.filters.tag.code;
      }
      return filters;
    },
    async batch_reviews_generate_logos_answer() {
      const review_ids = this.filtered_review_set.results.map(
          (review) => review.uid
      );
      await mutations.run("batch_reviews_generate_logos_answer", [review_ids]);
    },
    updateTaskStatus(updatedTask) {
      const index = this.review_set.results.findIndex(
          (review) => review.uid === updatedTask.object_id
      );
      if (index !== -1) {
        this.$set(this.review_set.results, index, {
          ...this.review_set.results[index],
          task_status: updatedTask.status,
          task_uid: updatedTask.uid,
        });
      }
    },
    listenToTaskUpdates() {
      this.$djangows["onmodelsignals"](
          {modelName: "task", appLabel: "core"},
          (event) => {
            this.updateTaskStatus(event.obj);
          }
      );
    },
    getStatusTitle(status) {
      switch (status) {
        case "PENDING":
          return "En attente de génération";
        case "SUCCESS":
          return "Génération effectuée";
        case "FAILED":
          return "Échec de la génération";
        case "IN_PROGRESS":
          return "Génération en cours";
        default:
          return "Statut inconnu";
      }
    },
    getTaskUrl(taskUid) {
      return `${settings.backendUrl}/admin/core/task/${taskUid}`;
    },
    refetchReviews() {
      this.loading = true;
      this.review_set.query(this.build_filters()).then(() => {
        this.loading = false;
      });
    },
  },
  mounted() {
    this.review_set.promise.then(() => {
      this.loading = false;
    });
    window.addEventListener("keydown", this.keydown);
    window.addEventListener("keyup", this.keyup);
    if (this.$route.params.uid) {
      this.$store.commit("select_review", this.$route.params.uid);
    }
    this.$refs.searchBox.focus();
  },
  created() {
    this.listenToTaskUpdates();
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.keydown);
    window.removeEventListener("keyup", this.keyup);
  },
  watch: {
    "$store.state.selected_consultant_uid"(newV) {
      this.loading = true;
      const filters = this.build_filters();
      this.review_set.query(filters).then(() => {
        this.loading = false;
      });
    },
    "$route.params"(newV, oldV) {
      if (newV.uid !== oldV.uid) {
        this.$store.dispatch("select_review", newV.uid);
      }
    },
    "filters.sentiment": "refetchReviews",
    "filters.status": "refetchReviews",
    "filters.dateBegin": "refetchReviews",
    "filters.dateEnd": "refetchReviews",
    "filters.establishment.uid": "refetchReviews",
    "filters.platform.uid": "refetchReviews",
    "filters.classified": "refetchReviews",
    "filters.tag": "refetchReviews",
    "$store.state.selected_review_uid"() {
      this.$refs.searchBox.focus();
    },
  },
};
</script>


<style lang="scss" scoped>
@import '../../node_modules/bulma/css/bulma';

.list {
  overflow-y: scroll;
  display: block;
}

.list-badge {
  overflow: hidden;
  display: block;
  width: 100%;
  text-overflow: ellipsis;

}

.list-item {
  padding: 5px;
}

.list-item:hover {
  cursor: pointer;
}

svg.icon-list {
  max-height: 14px;
  line-height: 1;
  vertical-align: -.125em;
}

.selected {
  // border-radius:0.25rem;
  background-color: #eee;
}

.review-title {
  font-size: 0.8em;
  text-overflow: ellipsis;
  width: 100%;
  white-space: nowrap;
  /*border:1px solid green;*/
  overflow: hidden;
  max-width: 35vw;
}

.state-name {
  width: calc(100% - 200px) !important;
}

.state-name > span {
  font-size: 1em !important;
  text-overflow: ellipsis !important;
  /*width: 125px;*/

  white-space: nowrap !important;
  /*border:1px solid green;*/
  overflow: hidden !important;
  text-align: left !important;
}

.date {
  font-size: 0.9em;
  padding-top: 3px;
}

.platform > span {
  /*font-size:1em !important;*/
  text-overflow: ellipsis !important;
  /*width: 45px;*/
  white-space: nowrap !important;
  /*border:1px solid green;*/
  overflow: hidden !important;
  text-align: left !important;
}

.mark > span {
  /*font-size:1em !important;*/
  text-overflow: ellipsis !important;
  width: 17px;
  white-space: nowrap !important;
  /*border:1px solid green;*/
  overflow: hidden !important;
  text-align: left !important;
}

.thumb {
  font-size: 0.75em !important;
  height: 25px;
}

.author {
  height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
}

.my-list-item {
  min-width: 250px;
}

.card-header {
  padding: 0 !important;
  display: flex;
}

.tag {
  background-color: rgba(0, 0, 0, 0);
}

.custom-scroll {
  height: calc(100vh - 170px) !important;
  overflow: auto;
}

.custom-badge {
  overflow: hidden;
  text-overflow: ellipsis;
  width: 180px;
  float: right;
}
</style>
